<template>
    <div>
        <div class="container-fluid px-0">
            <div class="position-absolute vh-100 w-100 top-0"
                :style="`background-image: url('https://www.devicemagic.com/wp-content/uploads/2021/07/person_using_smartphone-1.jpg'); background-size: cover; background-position: center; filter: grayscale(80%);z-index: -1;`">
            </div>
            <div class="row">
                <div class="col-lg-4 px-0">
                    <div class="card shadow rounded-0 pt-5 overflow-auto scrollable-content" style="min-height: 737px; height: 100vh;">
                        <div class="card-body">
                            <div class="row justify-content-center align-items-center">
                                <div class="col-lg-10">
                                    <div class="d-flex flex-column align-items-start">
                                        <img :src="logo" height="65">
                                    </div>
                                </div>
                                <div class="col-lg-10">
                                    <router-view :key="$route.fullPath"/>
                                    <div class="d-flex justify-content-center">
                                        <a :href="calculator" class="btn btn-block btn-neutral mt-2" target="_blank">Calculadora para clientes</a>
                                    </div>
                                    <hr>
                                    <div class="d-flex justify-content-center mb-5">
                                        Copyright ©{{ new Date().getFullYear() }} {{ app.name }}. Todos los derechos
                                        reservados.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import background from "@/assets/img/background.jpeg";
import logo from '@/assets/img/logo.png'
export default {
    data() {
        return {
            type: false,
            logo,
            background,
            app: {
                name: ''
            },
            calculator: 'https://vastago.cr/calculadora'
        }
    }
}
</script>
<style>
.scrollable-content::-webkit-scrollbar {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/pages/auth/Content.vue